import React from "react";
import PropTypes from "prop-types";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./fix.css";

const propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
};

const defaultProps = {
  id: null,
  name: null,
  placeholder: null,
  type: "markdown",
};

function Markdown({ ...props }) {
  return <ReactQuill {...props} />;
}

Markdown.propTypes = propTypes;
Markdown.defaultProps = defaultProps;

export default Markdown;
